import { IAllEventsMap } from "@/core/events/allEventsMap";
import { eventBusAdapter } from "@/infrastructure/adapters/events/EventBus.adapter";
import { EventRejection } from "@/infrastructure/services/events/EventBus";
import { useCallback, useEffect, useRef } from "react";

export function useEventBusSubscriber<K extends keyof IAllEventsMap>(
    event: K,
    callback: (payload: IAllEventsMap[K]) => void | Promise<void>
): void {
    const callbackRef = useRef(callback);

    useEffect(() => {
        callbackRef.current = callback;
    }, [callback]);

    useEffect(() => {
        const handler = (payload: IAllEventsMap[K]) => callbackRef.current(payload);
        eventBusAdapter.on(event, handler);

        return () => {
            eventBusAdapter.off(event, handler);
        };
    }, [event]);
}

export function useEventBusRejecter() {
    const  rejectSubscriber = (message?: string) => {
        throw new EventRejection(message ?? "Event rejected");
    };
    return useCallback((message?: string) => rejectSubscriber(message), []);
}